export const environment = {
  production: false,
};

export const baseUrl = 'https://driveup-dev.uptecra.com/';
export const BASEURL = 'https://driveup-dev.uptecra.com';

export const STATUS_VAR = Object.freeze({
  Waiting: "Waiting",
  Approved: "Approved",
  Rejected: "Rejected",
  Closed: "Closed",
  Ended: "Ended",
});

export const REFUND_STATUS = Object.freeze({
  WRONG_AMOUNT: "Yanlış Tutar",
  CUSTOMER_GRIEVANCE: "Müşteri Mağduriyeti",
  OTHER: "Diğer",
});

export const DOCUMENTS_VAR = Object.freeze({
  DriverLicense: "DriverLicense",
  UserSelfie: "UserSelfie",
  StudentCard: "StudentCard",
  CorporateCard: "CorporateCard",
});
